import { Subheading } from "@ecologi/react-components/src/Subheading";

export default Subheading;
